// extracted by mini-css-extract-plugin
export var aboveInput = "_nu-0";
export var actionButton = "_nu-5";
export var actionButtonContainer = "_nu-1";
export var actionIcon = "_nu-6";
export var aiInfoContainer = "_nu-2";
export var attachmentWrapper = "_nu-7";
export var bold = "_nu-3";
export var checkIcon = "_nu-8";
export var clickingRecipientBar = "_nu-11";
export var commentThreadSwitch = "_nu-a";
export var draftImage = "_nu-b";
export var draftImageContainer = "_nu-c";
export var draftImages = "_nu-e";
export var editButton = "_nu-g";
export var editor = "_nu-f";
export var editorContainer = "_nu-y";
export var editorErrorTooltipWrapper = "_nu-9";
export var headerDivider = "_nu-h";
export var icon = "_nu-i";
export var info = "_nu-j";
export var internal = "_nu-n";
export var internalDivider = "_nu-k";
export var internalMessage = "_nu-l";
export var messageInputCard = "_nu-m";
export var messageInputForm = "_nu-o";
export var messageInputFormInternal = "_nu-p";
export var options = "_nu-q";
export var publicMessageCustomer = "_nu-s";
export var publicMessageMerchant = "_nu-r";
export var removeImageButton = "_nu-d";
export var replyButtons = "_nu-t";
export var showSignatureButton = "_nu-u";
export var spinner = "_nu-v";
export var verticalButtonDivider = "_nu-4";
export var visibilitySelector = "_nu-w";
export var warning = "_nu-x";
export var wrappingText = "_nu-z";
export var writingInternalNoteTopBorder = "_nu-10";